export const compareLength = (array1: any[], array2: any[]) => {
	return array1.length === array2.length
}

export const compare = (array1: any[], array2: any[]) => {
	return compareLength(array1, array2) && array1.every((value, index) => value === array2[index])
}
